module.exports = __webpack_public_path__ + "img/notify.00c3909e.png";